<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceAdmin()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>My Employees | Service Manager</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="card card-primary card-outline">
                        <div class="card-header"></div>
                        <div class="card-body overflow-auto">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <span class="right badge badge-secondary"
                                        >Select From Date:</span
                                    >
                                    <input
                                        type="date"
                                        class="form-control"
                                        v-model="from"
                                        placeholder="Select From date"
                                    />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <span class="right badge badge-secondary"
                                        >Select To Date:</span
                                    >
                                    <input
                                        type="date"
                                        class="form-control"
                                        v-model="to"
                                        placeholder="Select To date"
                                    />
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <span class="right badge badge-secondary"
                                        >Search by Branch:</span
                                    >
                                    <v-select
                                        v-model="branch"
                                        class="form-control"
                                        type="text"
                                        label="branch"
                                        :options="branches"
                                        :reduce="
                                            (branches) => branches.branch_code
                                        "
                                        name="branch"
                                        placeholder="Select Branch"
                                        :value="
                                            (branches) => branches.branch_code
                                        "
                                    ></v-select>
                                </div>
                            </div>
                            <button
                                class="btn btn-primary"
                                @click="getData('/api/getEPAdmin')"
                            >
                                <i class="fa fa-search"></i>
                            </button>
                            {{ missing }}
                            <table
                                class="table table-striped table-bordered table-hover"
                            >
                                <thead>
                                    <tr>
                                        <th>Employee</th>
                                        <th>Paremeter</th>
                                        <th>Score</th>
                                        <th>Positive</th>
                                        <th>Negative</th>
                                        <th>Service Manager Approved</th>
                                        <th>Branch Manager Approved</th>
                                        <th>Manage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="g in grades">
                                        <td>{{ g.ename }}</td>
                                        <td>{{ g.parameter }}</td>
                                        <td>{{ g.score }}</td>
                                        <td>{{ g.positive }}</td>
                                        <td>{{ g.negative }}</td>
                                        <td>{{ g.sm_approved_name }}</td>
                                        <td>{{ g.bm_approved_name }}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">
                            <pagination
                                :pagination="pagination"
                                @prev="getData(pagination.prevPageUrl)"
                                @next="getData(pagination.nextPageUrl)"
                            ></pagination>
                        </div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { pagination: Pagination },

    created() {
        this.getData();
        this.getMissing();
        this.getBranches();
    },

    data() {
        return {
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            missing: [],
            grades: [],
            branches: [],
            from: "",
            to: "",
            branch: "",
        };
    },

    methods: {
        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        getData(url = "/api/getEPAdmin") {
            axios
                .post(url, {
                    branch: this.branch,
                    from: this.from,
                    to: this.to,
                })
                .then((response) => {
                    this.grades = response.data.data.data;
                    this.configPagination = response.data.data;
                });
        },

        getMissing() {
            axios.post("/api/missingBranches").then((response) => {
                this.missing = response.data;
            });
        },

        approve(id) {
            axios
                .post("/api/smApproveEP", { id: id })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Approved",
                        });
                        this.getData();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },
    },
};
</script>
